<template>
    <div>
        <el-tooltip class="item" effect="dark" content="点击扫码使用" placement="right-start">
            <div class="wechat-app" @click="wechatCode">
                <div><img :src="url" alt="" /></div>
                <span>小程序</span>
            </div>
        </el-tooltip>
        <whole-confirm ref="wholeConfirmRef"></whole-confirm>
    </div>
</template>

<script>
import {WinForm} from '@digital-supply-chain/module'
import {DomainService} from '@/libs'

export default {
    data() {
        return {
            url: `${DomainService.PublicPath}resource/images/icon/wxapp.png`,
            codeImgUrl: `${DomainService.PublicPath}resource/images/dggj.png`,
            appNameLabel: (WinForm.md.getAppNameLabel() || '大工程师').replace('企业版', ''),
        }
    },
    methods: {
        wechatCode() {
            this.$refs.wholeConfirmRef.open({
                width: '600px',
                content: `<div style="padding-left: 276px;position: relative;height: 272px;line-height: 38px;padding-bottom: 12px;">尊敬的${this.appNameLabel}们，<br/>${this.appNameLabel}小程序推出了，扫码登录您的${this.appNameLabel}账号，从此设计资源和供应链体系，可以随手获取了，<br/>积极推荐传播给您周边的朋友和同事吧，让全国的工程师们连接起来，建设技术领域的统一平台！<img style="width: 260px;position: absolute;left: 0;top: 0;" src="${this.codeImgUrl}" alt="" /></div>`,
                showConfirm: false,
                showCancel: true,
                cancelText: '关闭窗口',
            })
        }
    },
}
</script>

<style lang="less" scoped>
    .wechat-app{
        width: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #0989C5;
        line-height: 18px;
        position: absolute;
        left: -72px;
        top: 0;
        z-index: 1000;
        cursor: pointer;
        outline: none;
        img{
            width: 30px;
            height: 30px;
        }
    }
</style>
